<template>
  <nav class="kmutt-nav">
    <a :href="`/GiftEd/${$route.params.lang}/home`">
      <div class="nav-heading" >
        <img :src="`/${this.$staticPath}/images/logo.png`" alt="logo" :class="{visible: isLogoVisible}">
        <div id="kmutt-logo">ESC</div>
      </div>
    </a>
    <div class="container-fluid px-3">
      <div class="row">
        <div id="menuToggle">
          <input type="checkbox" />
          <span></span>
          <span></span>
          <span></span>
          <ul id="menu">
            <li v-for="(item, index) in menu" :key="index">
              <a :href="getNextPath(item)" :class="{active: item.isActive}"  v-if="!item.submenu">
                <i class="fa" :class="item.icon" aria-hidden="true" v-if="!item.icon.path"></i>
                <img :src="item.icon.path" v-if="item.icon.path" aria-hidden="true"/> {{item.description}}
              </a>
              <a class="dropdown-toggle" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" v-if="item.submenu">
                  <img :src="item.icon.path" alt="" style="width: 25px;" class="iconmenu25"/> {{ item.description }}
              </a>

              <div class="dropdown-menu" aria-labelledby="navbarDropdown" v-if="item.submenu">
                    <a  class="dropdown-item" :href="getNextPath(sub)" v-for="(sub,s) in item.submenu" :key="s">{{ sub.description }}</a>
              </div>
            </li>
          </ul>
        </div>

        <div class="col-md-12 text-right d-none d-lg-block">
          <ul>
            <li v-for="(item, index) in menu" :key="index" :class="`${item.submenu ? 'dropdown' : '' }`">
              <a :href="getNextPath(item)" :class="{active: item.isActive}" v-if="!item.submenu">
                <i class="fa" :class="item.icon" aria-hidden="true" v-if="!item.icon.path"></i>
                <img :src="item.icon.path" v-if="item.icon.path" aria-hidden="true"/> {{item.description}}</a>

              <a class="dropdown-toggle" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" v-if="item.submenu">
                  <img :src="item.icon.path" alt="" style="width: 25px;" class="iconmenu25"/> {{ item.description }}
              </a>

              <div class="dropdown-menu" aria-labelledby="navbarDropdown" v-if="item.submenu">
                    <a  class="dropdown-item" :href="getNextPath(sub)" v-for="(sub,s) in item.submenu" :key="s">{{ sub.description }}</a>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { throttle } from 'throttle-debounce'

export default {
  name: 'Navbar',
  props: ['lang'],
  data () {
    return {
      menu: [],
      isLogoVisible: false
    }
  },
  async created () {
    await this.init()
    this.activeMenu()
    if (this.$route.name === 'home') {
      window.addEventListener('scroll', throttle(100, this.onMoving), true)
    } else {
      window.removeEventListener('scroll', throttle(100, this.onMoving), true)
      this.isLogoVisible = true
    }
  },
  methods: {
    init: async function () {
      if (this.$route.params.lang === 'en') {
        var langData = await import('../../static/json/en/components/navbar.json')
      } else {
        langData = await import('../../static/json/th/components/navbar.json')
      }
      this.menu = langData.data.menu
    },
    activeMenu: function () {
      var namePath = this.$route.name === 'newsById' ? 'news' : this.$route.name
      var pos = this.menu.map(function (e) {
        return e.name
      }).indexOf(namePath)
      this.menu[pos].isActive = true
    },
    getNextPath: function (item) {
      let lng = this.$route.params.lang
      console.log('lng : ', lng, ' item : ', item)
      if (item.name === 'language' ) {
        if (item.isEnglish) {
          return `/GiftEd/th/${this.$route.path.slice(4)}`
        }
        return `/GiftEd/en/${this.$route.path.slice(4)}`
      }
      if (item.name.indexOf('view') !== -1) {    
        return `/view/${lng === 'en' ? lng : 'th'}${item.path}`
      }
      if(lng == 'th' || lng == 'en')
        return `/GiftEd/${lng}/${item.name}`
    },
    onMoving: function () {
      this.isLogoVisible = (window.scrollY > window.innerHeight)
    }
  }
}
</script>

<style scoped>
  @import url('../../static/css/components-style/navbar.css');
  .kmutt-nav .dropdown.show{
    display: inline-block !important;
  }
  .kmutt-nav ul li a{
    font-size:1em;
    padding:15px 8px;
  }
  .kmutt-nav ul li a.dropdown-toggle::after{
    display: inline-block;
    border-top:0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue